import { IconProps } from './types';
export const CheckCircleIcon = ({
  size = 24,
  color = 'currentColor',
  bgColor = 'transparent',
  id,
  ...props
}: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    id={id}
    fill={color}
    stroke={bgColor}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12m15.78-3.53a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l2.47 2.47 5.47-5.47a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
